import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll"; 
import "vanilla-match-height";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll<HTMLElement>(".card-slider");

  sliders.forEach((el) => {
    new Splide(el).mount({ AutoScroll });
  });

  // Optional TS safety for matchHeight
  if ((document.body as any).matchHeight) {
    (document.body as any).matchHeight({
      byRow: false,
      attributeName: "data-mh-card-slider",
    });
  }
});